import React, { useEffect, useState } from 'react'
import { dateAndTimeDiff } from 'lib/utils/dateAndTimeDiff'
import Logo from '../../assets/logo.png'
import Kapsul from '../../assets/kapsul2.png'
import InfoSquare from '../../assets/info_square.png'
import BgMobile from '../../assets/bg_mobile.png'

type Props = {
  senderName: string
  capsuleName: string
  openingDate: string
  onNext: () => void
}

const GiftScreen: React.FC<Props> = ({
  senderName,
  capsuleName,
  openingDate,
  onNext,
}) => {
  const [diff, setDiff] = useState<{
    days: number
    hours: number
    minutes: number
    seconds: number
  } | null>(null)

  useEffect(() => {
    const targetDate = new Date(openingDate)

    const updateDiff = () => {
      const now = new Date()
      if (targetDate < now) {
        setDiff({ days: 0, hours: 0, minutes: 0, seconds: 0 })
      } else {
        setDiff(dateAndTimeDiff(targetDate, now))
      }
    }

    updateDiff()
    const interval = setInterval(updateDiff, 1000)

    return () => clearInterval(interval)
  }, [openingDate])

  if (!diff) return null

  return (
    <div
      className="fixed inset-0 w-screen h-screen flex flex-col"
      style={{
        background: '#181B1E',
        backgroundImage: `url(${BgMobile})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[350px] h-[350px] bg-[#DFFF00]/8 rounded-full blur-[120px]" />

      {/* Content */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-8 relative z-10 overflow-y-auto overflow-x-hidden">
        {/* Logo */}
        <div className="mb-8 sm:mb-12">
          <img src={Logo} alt="TextToNext" className="h-[25px]" />
        </div>

        {/* Sender Info */}
        <p
          className="text-white text-center mb-2"
          style={{
            fontFamily: 'MorebiRounded, sans-serif',
            fontWeight: 300,
            fontSize: '14px',
            lineHeight: '18px',
          }}
        >
          <span className="text-[#DFFF00]">{senderName}</span> sana
        </p>
        <h2
          className="text-white text-center mb-6 sm:mb-8"
          style={{
            fontFamily: 'MorebiRounded, sans-serif',
            fontSize: '18px',
            lineHeight: '22px',
            fontWeight: 600,
          }}
        >
          ''{capsuleName}''
        </h2>
        <p
          className="text-white text-center mb-8 sm:mb-12"
          style={{
            fontFamily: 'MorebiRounded, sans-serif',
            fontWeight: 300,
            fontSize: '14px',
            lineHeight: '18px',
          }}
        >
          isimli bir Zaman Kapsülü hediye etti.
        </p>

        {/* Kapsul Image */}
        <div className="mb-8 sm:mb-12">
          <img
            src={Kapsul}
            alt="Kapsül"
            className="w-auto h-auto max-w-[150px] sm:max-w-[200px]"
          />
        </div>

        {/* Countdown Title */}
        <p
          className="text-white text-center mb-4 sm:mb-6"
          style={{
            fontFamily: 'MorebiRounded, sans-serif',
            fontWeight: 300,
            fontSize: '14px',
            lineHeight: '18px',
          }}
        >
          Kapsülün açılmasına kalan süre:
        </p>

        {/* Countdown */}
        <div className="flex justify-center gap-4 sm:gap-8 mb-8 sm:mb-12 flex-wrap pt-6 sm:pt-10 pb-10 sm:pb-20">
          <div
            className="flex flex-col items-center gap-2"
            style={{ padding: '3px' }}
          >
            <div
              className="text-white"
              style={{
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 700,
                fontSize: '24px',
                lineHeight: '1',
              }}
            >
              {diff.days}
            </div>
            <div
              className="text-white"
              style={{
                fontFamily: 'MorebiRounded, sans-serif',
                fontWeight: 300,
                fontSize: '12px',
              }}
            >
              Gün
            </div>
          </div>
          <div
            className="flex flex-col items-center gap-2"
            style={{ padding: '3px' }}
          >
            <div
              className="text-white"
              style={{
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 700,
                fontSize: '24px',
                lineHeight: '1',
              }}
            >
              {diff.hours}
            </div>
            <div
              className="text-white"
              style={{
                fontFamily: 'MorebiRounded, sans-serif',
                fontWeight: 300,
                fontSize: '12px',
              }}
            >
              Saat
            </div>
          </div>
          <div
            className="flex flex-col items-center gap-2"
            style={{ padding: '3px' }}
          >
            <div
              className="text-white"
              style={{
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 700,
                fontSize: '24px',
                lineHeight: '1',
              }}
            >
              {diff.minutes}
            </div>
            <div
              className="text-white"
              style={{
                fontFamily: 'MorebiRounded, sans-serif',
                fontWeight: 300,
                fontSize: '12px',
              }}
            >
              Dakika
            </div>
          </div>
          <div
            className="flex flex-col items-center gap-2"
            style={{ padding: '3px' }}
          >
            <div
              className="text-white"
              style={{
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 700,
                fontSize: '24px',
                lineHeight: '1',
              }}
            >
              {diff.seconds}
            </div>
            <div
              className="text-white"
              style={{
                fontFamily: 'MorebiRounded, sans-serif',
                fontWeight: 300,
                fontSize: '12px',
              }}
            >
              Saniye
            </div>
          </div>
        </div>

        {/* Info Message */}
        <div
          className="flex items-start gap-4 max-w-sm"
          style={{ padding: '8px', marginBottom: '16px' }}
        >
          <img
            src={InfoSquare}
            alt="Info"
            className="w-4 h-4 sm:w-5 sm:h-5 mt-1 flex-shrink-0"
          />
          <p
            className="text-white text-left"
            style={{
              fontFamily: 'MorebiRounded, sans-serif',
              fontWeight: 300,
              fontSize: '13px',
              lineHeight: '18px',
              marginLeft: '2px',
            }}
          >
            Zamanı geldiğinde görebilmek için sen de kaydını oluştur.
          </p>
        </div>

        {/* Button */}
        <button
          onClick={onNext}
          className="text-black rounded-2xl transition-all active:scale-[0.98] mb-4"
          style={{
            background: '#D6FF00',
            width: '340.25px',
            height: '45.12px',
            maxWidth: '90vw',
            fontFamily: 'MorebiRounded, sans-serif',
            fontWeight: 600,
            fontSize: '18px',
          }}
        >
          Kayıt Oluştur
        </button>
      </div>
    </div>
  )
}

export default GiftScreen
